// ============================================
// PAGE PRODUIT — Galerie + Quantité + ATC Shopify AJAX
// ============================================

document.addEventListener('DOMContentLoaded', () => {

    // 1. GALERIE : clic thumb change image
    const mainImg = document.getElementById('pmMainImg');
    const thumbsStrip = document.querySelector('.product-media__thumbs');
    const thumbs = document.querySelectorAll('.product-media__thumbs .thumb');

    // Défilement fluide avec filet de secours (Safari anciens / smooth inactif)
    const glisserVers = (cible) => {
        if (!thumbsStrip) return;
        const avant = thumbsStrip.scrollLeft;
        try {
            thumbsStrip.scrollTo({ left: cible, behavior: 'smooth' });
        } catch (e) {
            thumbsStrip.scrollLeft = cible;
            return;
        }
        setTimeout(() => {
            if (Math.abs(thumbsStrip.scrollLeft - avant) < 1 && Math.abs(cible - avant) > 1) {
                thumbsStrip.style.scrollBehavior = 'auto';
                thumbsStrip.scrollLeft = cible;
                thumbsStrip.style.scrollBehavior = '';
            }
        }, 250);
    };

    thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
            const src = btn.dataset.src;
            if (src && mainImg) mainImg.src = src;
            thumbs.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            // Centrer la vignette cliquée dans le carrousel
            if (thumbsStrip) {
                glisserVers(btn.offsetLeft - (thumbsStrip.clientWidth - btn.offsetWidth) / 2);
            }
        });
    });

    // 1bis. CARROUSEL de vignettes : flèches injectées si débordement
    if (thumbsStrip && thumbs.length > 1) {
        const wrap = document.createElement('div');
        wrap.className = 'thumbs-carousel';
        thumbsStrip.parentNode.insertBefore(wrap, thumbsStrip);
        wrap.appendChild(thumbsStrip);

        const mkNav = (dir, label, char) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'thumbs-nav thumbs-nav--' + (dir < 0 ? 'prev' : 'next');
            b.setAttribute('aria-label', label);
            b.textContent = char;
            b.addEventListener('click', () => {
                glisserVers(thumbsStrip.scrollLeft + dir * thumbsStrip.clientWidth * 0.8);
            });
            wrap.appendChild(b);
            return b;
        };
        const navPrev = mkNav(-1, 'Vignettes précédentes', '❮');
        const navNext = mkNav(1, 'Vignettes suivantes', '❯');

        const updateNav = () => {
            const max = thumbsStrip.scrollWidth - thumbsStrip.clientWidth;
            navPrev.hidden = max <= 4 || thumbsStrip.scrollLeft <= 2;
            navNext.hidden = max <= 4 || thumbsStrip.scrollLeft >= max - 2;
        };
        thumbsStrip.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        setInterval(updateNav, 600);
        updateNav();
    }

    // 2. STEPPER QUANTITÉ
    document.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const wrap = btn.closest('.qty-selector');
            if (!wrap) return;
            const input = wrap.querySelector('.qty-input');
            if (!input) return;
            let val = parseInt(input.value, 10) || 1;
            if (btn.dataset.action === 'plus') val++;
            else if (btn.dataset.action === 'minus' && val > 1) val--;
            input.value = val;
        });
    });

    // 3. ATC SHOPIFY AJAX
    const updateCartCount = async () => {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            document.querySelectorAll('.cart-count').forEach(el => {
                el.textContent = cart.item_count;
            });
            return cart;
        } catch (err) { console.error('Cart update error', err); }
    };

    const showFeedback = (btn, success = true, msg = null) => {
        if (!btn.dataset._orig) btn.dataset._orig = btn.textContent;
        btn.textContent = msg || (success ? '✓ Ajouté' : 'Erreur');
        btn.style.background = success ? '#28a745' : '#dc3545';
        btn.style.color = '#fff';
        setTimeout(() => {
            btn.textContent = btn.dataset._orig;
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
        }, 1800);
    };

    // Mapping pages produit → handles Shopify
    const pageToHandle = {
        'produit-7-0-at': 'tapis-7-0-at',
        'produit-t101': 'tapis-t101-connect',
        'produit-5-0-r': 'velo-5-0-r',
        'produit-5-0-u': 'velo-5-0-u',
        'produit-ex-59': 'elliptique-ex-59',
        'produit-tapis-de-sol': 'tapis-de-sol-fitness',
        'produit-lube-n-walk': 'kit-lube-n-walk',
        'produit-lubrifiant-silicone': 'lubrifiant-silicone-lot-3',
        'produit-ceinture-cardio': 'ceinture-cardio-thoracique'
    };

    // Trouver le handle produit à partir d'un bouton
    const findHandle = (btn) => {
        if (btn.dataset.atcHandle) return btn.dataset.atcHandle;
        const card = btn.closest('.product-card, [data-product-handle]');
        if (card?.dataset.productHandle) return card.dataset.productHandle;
        if (card) {
            // Chercher lien /products/XXX
            const pl = card.querySelector('a[href*="/products/"]');
            if (pl) {
                const m = pl.getAttribute('href').match(/\/products\/([^/?#]+)/);
                if (m) return m[1];
            }
            // Chercher lien /pages/produit-XXX
            const pagL = card.querySelector('a[href*="/pages/produit-"]');
            if (pagL) {
                const m = pagL.getAttribute('href').match(/\/pages\/(produit-[^/?#]+)/);
                if (m && pageToHandle[m[1]]) return pageToHandle[m[1]];
            }
        }
        // URL actuelle si page produit
        const currentMatch = window.location.pathname.match(/\/pages\/(produit-[^/?#]+)/);
        if (currentMatch && pageToHandle[currentMatch[1]]) return pageToHandle[currentMatch[1]];
        return null;
    };

    const addToCart = async (handle, qty, btn) => {
        try {
            const prodRes = await fetch(`/products/${handle}.js`);
            if (!prodRes.ok) throw new Error('Produit introuvable');
            const product = await prodRes.json();
            const variant = product.variants.find(v => v.available) || product.variants[0];
            if (!variant) throw new Error('Pas de variant');

            const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: variant.id, quantity: qty })
            });
            if (!addRes.ok) {
                const e = await addRes.json().catch(() => ({}));
                throw new Error(e.description || 'Erreur ATC');
            }
            await updateCartCount();
            if (btn) showFeedback(btn, true);
            return true;
        } catch (err) {
            console.error('ATC error', err);
            if (btn) showFeedback(btn, false, 'Indispo');
            return false;
        }
    };

    // Attacher aux boutons sur cartes produit et pages produit
    document.querySelectorAll('.product-card__atc, .btn-cart, .btn-atc').forEach(btn => {
        // Skip si form natif Shopify
        if (btn.type === 'submit' && btn.closest('form[action*="/cart/add"]')) return;

        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (btn.disabled) return;

            const handle = findHandle(btn);
            if (!handle) {
                showFeedback(btn, false, 'Produit manquant');
                return;
            }
            const qtyInput = btn.closest('.product-info')?.querySelector('.qty-input')
                          || document.querySelector('.product-info .qty-input');
            const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

            btn.disabled = true;
            btn.dataset._orig = btn.textContent;
            btn.textContent = '...';
            await addToCart(handle, qty, btn);
        });
    });

    // 4. STICKY ATC BAR scroll
    const stickyBar = document.querySelector('.sticky-atc');
    const productMain = document.querySelector('.product-main');
    if (stickyBar && productMain) {
        window.addEventListener('scroll', () => {
            const rect = productMain.getBoundingClientRect();
            if (rect.bottom < 0) stickyBar.classList.add('is-visible');
            else stickyBar.classList.remove('is-visible');
        }, { passive: true });
    }

    updateCartCount();
});
